'use client';

import { LinkPlugin } from '@platejs/link/react';

import { LinkElement } from '@/components/ui/platejs/link-node';

export const LinkKit = [
  LinkPlugin.configure({
    render: {
      node: LinkElement,
      //afterEditable: () => <LinkFloatingToolbar />,
    },
  }),
];
